/* eslint-disable @typescript-eslint/indent */
import React, { useContext } from 'react';
import { Typography, Container } from '@pwskills/rachnaui';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
import { companyImage } from '@/utils/common/env.constants';
import Headers from '@/components/common/Header';
import useScreenWidth from '@/hooks/useScreenWidth';
import { useRouter } from 'next/router';

const CourseOfferingSection = () => {
  const { courseDetails } = useContext(CourseDescriptionContext);
  const { courseOffering } = courseDetails?.courseMetaDetails || {};
  const screenWidth = useScreenWidth();
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  const getGridColumnsClass = (width: number): string => {
    if (width >= 1200 && width < 1354) {
      return 'grid-cols-3';
    }
    if (width >= 1354) {
      return 'grid-cols-4';
    }
    return 'grid-cols-2';
  };
  const returnChildren = () => {
    return (
      <>
        {isDashboard ? (
          <Typography component="h4" variant="semi-bold">
            Course Offerings
          </Typography>
        ) : (
          <Headers
            title="Exclusive Course Offerings"
            classes="flex !min-w-full justify-center text-gray-850"
          />
        )}

        <div
          className={`${getGridColumnsClass(
            screenWidth as number
          )} grid items-center  gap-[1px]  bg-gradient-to-b from-transparent via-[#dcdcdc] to-transparent`}
        >
          {courseOffering?.map(({ icon, name }) => (
            <div
              className="flex bg-white flex-col items-center pt-3 gap-[28px] pb-5 !h-full"
              key={name}
            >
              <img
                src={`${companyImage}/course_offering_icons/${icon?.link}`}
                alt="course offerings"
                className="w-[72px] h-[72px]"
                height={72}
                width={72}
              />
              <Typography component="body-regular" variant="semi-bold" className="text-center">
                {name}
              </Typography>
            </div>
          ))}
        </div>
      </>
    );
  };
  if (courseOffering && courseOffering?.length > 0) {
    if (isDashboard) {
      return (
        <div className="flex pb-8 pt-16 large:!pb-14  large:!pt-14 flex-col gap-4">
          {returnChildren()}
        </div>
      );
    }
    return (
      <Container className="flex pb-8 pt-16 large:!pb-14  large:!pt-14 flex-col gap-4">
        {returnChildren()}
      </Container>
    );
  }
  return null;
};

export default CourseOfferingSection;
